/* example
    const menu = new Menu({
        button: '.js-toggle-menu',
        elToMove: '.page-body',
        menuToMove: '.page-menu',
        pageHeader: '.page-header'
        menuWrapper: '.menu',
        classToAdd: 'is-open',
        elToAnimate: '.menu__link',
        animateClass: 'is-visible',
        delay : 100,
        headerHeight: 180
    });
*/

export default class Menu{
    constructor(args){
        this.button = document.querySelectorAll(args.button);
        this.elToMove = document.querySelector(args.elToMove);
        this.menuToMove = document.querySelector(args.menuToMove);
        this.pageHeader = document.querySelector(args.pageHeader);
        this.menuWrapper = document.querySelector(args.menuWrapper);
        this.submenu = document.querySelectorAll('.sub-menu');
        this.classToAdd = (args.classToAdd) ? args.classToAdd : 'is-open';
        this.elToAnimate = document.querySelectorAll(args.elToAnimate);
        this.animateClass = args.animateClass;
        this.delay = args.delay;
        this.headerHeight =  (args.headerHeight) ? args.headerHeight : 130;
        this.desktopHeaderHeight =  0;
        this.scroll = window.pageYOffset;
        this.window_width =  window.innerWidth;

        if(this.window_width >= 992)
            this.sub_top_pos();

        this.bindEvents();
        this.default_settings();
    }
    bindEvents() {
        this.button.forEach(item => {
            item.addEventListener('click', ()=>{            
                this.toggle_move();
            }); 
        });
        
        window.addEventListener('scroll', ()=>{
            this.onScroll();
        });

        window.addEventListener('resize', 
            _.debounce(() => {
                let window_width =  window.innerWidth;
                if(window_width >= 992)
                    this.sub_top_pos();
            }, 500)
        );              
	}
	toggle_move(){
        this.elToMove.classList.toggle(this.classToAdd);
        this.menuToMove.classList.toggle(this.classToAdd);
        this.animate();
    }
    onScroll(){        
        let scrolled = window.pageYOffset;
        if (scrolled > this.headerHeight) {
            this.pageHeader.classList.add('is-scrolled-down');
            this.menuToMove.classList.add('is-scrolled-down');
        } else {
            this.pageHeader.classList.remove('is-scrolled-down');
            this.menuToMove.classList.remove('is-scrolled-down');
        }

        if (scrolled > this.desktopHeaderHeight) {
            this.menuToMove.classList.add('is-desktop-scrolled-down');
        } else {
            this.menuToMove.classList.remove('is-desktop-scrolled-down');
        }    

        if (scrolled > this.scroll) {
            this.pageHeader.classList.remove('is-scrolled-up');
            this.menuToMove.classList.remove('is-scrolled-up');
        } else {
            this.pageHeader.classList.add('is-scrolled-up');
            this.menuToMove.classList.add('is-scrolled-up');
        }
        this.scroll = window.pageYOffset; 
    }
    animate(){
        let delay = this.delay;
        this.elToAnimate.forEach(item => {
            setTimeout(()=>{
                item.classList.toggle(this.animateClass);
            },delay);
            delay+=150;
        });       
    }
    default_settings(){
        if(this.scroll > this.headerHeight){
            this.pageHeader.classList.add('is-scrolled-down');
        }
    }
    sub_top_pos(){        
        this.submenu.forEach(el => {
            el.style.left = `-${el.parentNode.offsetLeft}px`;
        });
    }

}